var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGChevronLeftGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24.5,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(-180 24 24.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7071 7.79289C15.0976 8.18342 15.0976 8.81658 14.7071 9.20711L11.4142 12.5L14.7071 15.7929C15.0976 16.1834 15.0976 16.8166 14.7071 17.2071C14.3166 17.5976 13.6834 17.5976 13.2929 17.2071L9.29289 13.2071C8.90237 12.8166 8.90237 12.1834 9.29289 11.7929L13.2929 7.79289C13.6834 7.40237 14.3166 7.40237 14.7071 7.79289Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGChevronLeftGrey);
export default __webpack_public_path__ + "static/media/g-chevron-left-grey.58304d1f594bfc7d766837f3b624a968.svg";
export { ForwardRef as ReactComponent };